module.exports = __webpack_public_path__ + "static/img/invalidSearch.4422b9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/invalidSearch.png
// module id = HWVS
// module chunks = 8